import type { IconProps } from '../types/IconProps.ts';
export const File: IconProps = {
    name: 'File',
    children: [
        `<path d="M4 4c0-1.1.9-2 2-2h7.17a2 2 0 0 1 1.42.59L19.4 7.4a2 2 0 0 1 .6 1.43V20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z" />`,
        `<path d="M13 2v5c0 1.1.9 2 2 2h5" />`,
    ]
};